import { ModelSagres } from "../model-sagres";

export class DepartamentoResumido extends ModelSagres {
  Id?: number;
  Ativo: boolean;
  CodEtce: number;
  Nome: string;
  Sigla: string;

  /**
   * Usar o parâmetro opcional para receber um objeto das APIs
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.Id = obj.Id;
      this.Ativo = obj.Ativo;
      this.CodEtce = obj.CodEtce;
      this.Nome = obj.Nome;
      this.Sigla = obj.Sigla;
    }
  }
}
